import { ApplicationConfig, provideZonelessChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideFirebaseApp, initializeApp } from "@angular/fire/app";
import { provideAnalytics, getAnalytics, ScreenTrackingService } from "@angular/fire/analytics";
import { routes } from "./app.routes";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideHttpClient } from '@angular/common/http';
import { provideNgxScrollAnimations } from 'ngx-scroll-animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp({
      projectId: "ooh-vision-pro",
      appId: "1:1065079192945:web:ebc2376a19a5e04a560ad0",
      storageBucket: "ooh-vision-pro.firebasestorage.app",
      apiKey: "AIzaSyAIsJAIYoGf48A3qdOtEIMap6KyZFAFs5Y",
      authDomain: "ooh-vision-pro.firebaseapp.com",
      messagingSenderId: "1065079192945",
      measurementId: "G-XEEB4529YK",
    })),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    provideHttpClient(),
    provideAnimations(),
    provideNgxScrollAnimations({
      duration: 400,
      animationName: 'fade-in-up',
      once: true,
      threshold: 0.4
    }),
  ],
};
